<template>
  <v-card tile class="notes" min-width="335px">
    <v-toolbar tile flat>
      <v-subheader>Alerts</v-subheader>
      <v-spacer />
      <!--<v-btn text @click="handleClearNotification">clear</v-btn>-->
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-list dense class="pa-0 notes_list" v-if="alerts.length > 0">
        <template v-for="(alert, index) in alerts">
          <v-list-item :key="index" @click="handleClick(alert)">
            <v-list-item-content>
              <v-list-item-subtitle
                v-html="alert.subject"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="caption">
              {{ new Date(alert.updatedAt) | formattedDateAndTime }}
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="'d' + index" />
        </template>
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-list-item-content class="text-center"
            >You have no unread alerts.
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-btn block text class="ma-0" to="/alerts">All</v-btn>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    alerts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {
    handleClick(alert) {
      this.$router.push({ path: `/alerts/${alert.id}` })
    },
  },
}
</script>
<style lang="sass" scoped>
.notes_list
  max-height: 360px
  overflow-y: auto
</style>
